export const koloLinksConstants = {
  REQUEST_LINKS: 'REQUEST_LINKS',
  REQUEST_LINKS_FINISHED: 'REQUEST_LINKS_FINISHED',
  SET_CURRENT_LINK: 'SET_CURRENT_LINK'
};